import React, { useState } from "react";
import vk from "../assets/VKRemove.webp";
import YoutubeLogo from "../assets/Youtube_Logo.webp";

const VideoSection = () => {
  const [isPopOpen, setIsPopOpen] = useState(false);

  const openModal = () => setIsPopOpen(true);
  const closeModal = () => setIsPopOpen(false);

  return (
    <>
      <section
        id="video"
        className="py-8 md:py-12 flex flex-col justify-center items-center bg-[#090522] px-4"
      >
        <h2 className="text-3xl text-yellow-400 font-bold text-center mb-6 md:mb-8">
          <span className="text-orange-500">EXPLORE </span>OUR WORLD
        </h2>
        <div
          className="relative w-full max-w-3xl cursor-pointer"
          onClick={openModal}
        >
          <img src={vk} alt="Meet VK" className="w-full rounded-lg shadow-lg" />

          {/* YouTube Logo in the center with animation */}
          <img
            src={YoutubeLogo}
            alt="YouTube Logo"
            className="absolute inset-0 m-auto w-[150px] h-[80px] md:w-[200px] md:h-[100px] animate-blink"
          />
        </div>
        {isPopOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
            <div className="bg-black rounded-lg overflow-hidden relative w-[90%] max-w-4xl h-[70vh]">
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 text-white text-2xl font-bold z-50"
              >
                &times;
              </button>
              <iframe
                src="https://www.youtube.com/embed/ens-q6Rt_FM?autoplay=1"
                title="VK Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default VideoSection;
